import { useQuery } from '@apollo/client';
import type { UseProvidersListFetch } from '@openx/components-segment/lib/utils/context/SegmentHookTypes';
import { Order_By } from '@openx/types/gqlTypes';
import { GetProvidersListDocument } from '../../../graphql/query/providers/GetProvidersList.generated';

export const useProvidersListFetch: UseProvidersListFetch = (accountUid: string) => {
  const {
    data: { provider: providers } = {},
    error,
    loading,
  } = useQuery(GetProvidersListDocument, {
    variables: {
      order_by: [{ name: Order_By.Asc }],
      where: {
        allowed_accounts: {
          account: {
            id: { _eq: accountUid },
          },
        },
      },
    },
  });

  return {
    error,
    loading,
    providers: providers ?? [],
  };
};
